import forOwn from 'lodash/forOwn';
import isString from 'lodash/isString';

interface Style {
  feature?: string;
  element?: string;
  [key: string]: string | undefined;
}

function makeStyle(style: Style) {
  const list: Array<string> = [];
  let url = '';

  if (isString(style.feature)) {
    list.push('feature:' + style.feature);
  }

  if (isString(style.element)) {
    list.push('element:' + style.element);
  }

  forOwn(style, function (value, key) {
    if (key !== 'feature' && key !== 'element' && isString(value)) {
      list.push(key + ':' + value);
    }
  });

  if (list.length > 0) {
    url += list.join('%7C') + '%7C';
  }
  return url;
}

function makeLocations(paths: Array<{ lat: number; lng: number }> = []) {
  const list: Array<string> = [];
  let url = '';
  let path;
  let i;

  for (i = 0; i < paths.length; i++) {
    path = paths[i];
    list.push(path.lat + ',' + path.lng);
  }
  if (list.length > 0) {
    url += list.join('%7C');
  }
  return url;
}

function makeMarkers(lat: number, lng: number) {
  return [
    {
      style: { color: 'blue' },
      locations: [
        {
          lat,
          lng,
        },
      ],
    },
  ];
}

class StaticMap {
  url = 'https://maps.googleapis.com/maps/api/staticmap?';

  center = (lat: number, lng: number) => {
    this.url += 'center=';
    if (isString(lat)) {
      this.url += lat;
    } else {
      this.url += lat + ',' + lng;
    }
    this.url += '&';
    return this;
  };

  size = (width: number, height: number) => {
    this.url += 'size=';
    this.url += width + 'x' + height;
    this.url += '&';
    return this;
  };

  scale = (scale: number) => {
    this.url += 'scale=';
    this.url += scale;
    this.url += '&';
    return this;
  };

  zoom = (zoom: number) => {
    this.url += 'zoom=';
    this.url += zoom;
    this.url += '&';
    return this;
  };

  type = (type: string) => {
    this.url += 'maptype=';
    this.url += type;
    this.url += '&';
    return this;
  };

  markers = (lat: number, lng: number) => {
    const markerGroups = makeMarkers(lat, lng);
    markerGroups.forEach((markerGroup) => {
      this.url += 'markers=';
      this.url += makeStyle(markerGroup.style);
      this.url += makeLocations(markerGroup.locations);
      this.url += '&';
    });

    return this;
  };

  path = (style: Style, locations: Array<{ lat: number; lng: number }> = []) => {
    this.url += 'path=';
    this.url += makeStyle(style);
    this.url += makeLocations(locations);
    this.url += '&';
    return this;
  };

  style = (style: Style) => {
    this.url += 'style=';
    this.url += makeStyle(style);
    this.url += '&';
    return this;
  };

  key = (key: string) => {
    this.url += 'key=';
    this.url += key;
    this.url += '&';
    return this;
  };
}

export default StaticMap;
